import {gql} from "@apollo/client"

const GET_MUTUAL_FUNDS=gql`
    query GetMutualFunds{
        getMutualFunds{
            id
            name
            category
            amcName
        }
    }
`;

export default GET_MUTUAL_FUNDS;